export default __webpack_public_path__ + "static/media/client2.3a9a9ccc.png";